import { Box } from '@material-ui/core';
import {
  getMerchantDataById,
  MerchantData,
  patchSetLegalAddress,
  postCreateMerchantData,
} from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { MerchantLegalAddressForm } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantLegalAddress/components/MerchantLegalAddressForm';
import {
  MerchantLegalAddressSchema,
  MerchantLegalAddressType,
} from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantLegalAddress/schemas/MerchantLegalAddressSchema';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { ADDRESS_BLANK_VALUES } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/constants/AddressBlankValues';
import { AddressMap } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/maps/address.map';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface MerchantLegalAddressEditDialogProps {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  merchantId: string;
  merchantData?: MerchantData;
}

export const MerchantLegalAddressEditDialog = ({
  opened,
  setOpened,
  toggleDialog,
  merchantId,
  merchantData,
}: MerchantLegalAddressEditDialogProps) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getMerchantDataById, { merchantId });

  const merchantLegalAddressDefaultValues = {
    legalAddress: merchantData?.legalAddress ? AddressMap.toForm(merchantData.legalAddress) : ADDRESS_BLANK_VALUES,
  };

  const onSubmitForm = async (formValues: MerchantLegalAddressType) => {
    if (!merchantData) {
      await request(postCreateMerchantData, {
        id: merchantId,
        merchantGroupId: uuidv4(),
        legalAddress: AddressMap.toDto(formValues.legalAddress),
      });
    } else {
      await request(patchSetLegalAddress, {
        id: merchantId,
        legalAddress: AddressMap.toDto(formValues.legalAddress),
      });
    }
    toggleDialog();
    revalidate();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={!merchantData ? 'ADD_LEGAL_ADDRESS' : 'EDIT_LEGAL_ADDRESS'}
      onSubmitForm={onSubmitForm}
      isLoading={loading}
      defaultValues={merchantLegalAddressDefaultValues}
      formSchema={MerchantLegalAddressSchema}
    >
      <Box pt={2}>
        <MerchantLegalAddressForm merchantData={merchantData} fieldVariant={FieldVariant.form} fullWidth />
      </Box>
    </EditDialogWrapper>
  );
};
